import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MuiSelect from '@mui/material/Select';
import React from 'react';
import uniqueId from 'lodash/uniqueId';

import PropTypes from 'prop-types';

function Select({ label, ...props }) {
	const labelId = `order-fiters-${uniqueId()}`;

	return (
		<FormControl fullWidth>
			<InputLabel id={labelId} variant="outlined" margin="dense">
				{label}
			</InputLabel>
			<MuiSelect
				label={label}
				labelId={labelId}
				variant="outlined"
				margin="dense"
				{...props}
			></MuiSelect>
		</FormControl>
	);
}

Select.propTypes = {
	label: PropTypes.any,
};

export default React.memo(Select);
